//PACKS
import React, { useState, useEffect } from "react";
import { useSpring, animated } from "react-spring";

//COMPONENTS
import ProductInfoMobile from "./ProductInfoMobile";

//STYLES
import "../styles/productMobile.scss";

export default function ProductMobile(props) {
  //STATE
  const [toggle, setToggle] = useState(false);

  //ON TOGGLE CHANGE
  useEffect(() => {
    let bg = toggle ? props.product.picture : null;
    props.handleBackgroundImage(bg);
    props.handleCurrentSlide(props.index);
  }, [toggle]);

  useEffect(() => {
    if (props.index !== props.currentSlide) {
      setToggle(false);
    }
  }, [props]);

  //ANIMATIONS
  const productPicToggle = useSpring({
    opacity: toggle ? "0" : "1",
  });

  return (
    <div className="productContainerMobile">
      <animated.div
        className="productMobile"
        onClick={() => {
          setToggle(!toggle);
        }}
      >
        {toggle ? <ProductInfoMobile product={props.product} /> : <></>}
        <animated.img style={productPicToggle} src={props.product.picture} />
      </animated.div>
    </div>
  );
}
